import { IconProps } from '.';

const KeyIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142905)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.1826 13.9972L27.7182 10.4617L31.5483 14.2918L33.3161 12.5241L29.4859 8.69391L30.9591 7.22077L29.1913 5.45301L16.7511 17.8932C13.4895 15.4846 8.86965 15.7573 5.91569 18.7113C2.66133 21.9656 2.66132 27.242 5.91569 30.4964C9.17006 33.7507 14.4464 33.7507 17.7008 30.4964C20.6548 27.5424 20.9274 22.9225 18.5188 19.661L22.4148 15.765L25.6558 19.0059L27.4235 17.2381L24.1826 13.9972ZM15.933 28.7286C13.655 31.0067 9.96152 31.0067 7.68346 28.7286C5.4054 26.4505 5.4054 22.7571 7.68346 20.479C9.96152 18.201 13.655 18.201 15.933 20.479C18.2111 22.7571 18.2111 26.4505 15.933 28.7286Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142905">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeyIcon;
